function toDate(date) {
  let dayBirth = date.substring(0, 2);
  let monthBirth = date.substring(3, 5);
  let yearBirth = date.substring(6, 10);
  return new Date(`${yearBirth}-${monthBirth}-${dayBirth}`);
}

export default toDate;
